var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"range-input",attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"type":"range","min":_vm.min,"max":_vm.max},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onInput($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }